// extracted by mini-css-extract-plugin
module.exports = {"btn-del":"DeleteList_btn-del__24-7W","del-text":"DeleteList_del-text__2dfR8","wrapper":"DeleteList_wrapper__1_ois"};